module.exports = __webpack_public_path__ + "static/hero-home-3e5056b178deb75b5e1f948fb54bb251.png";